export default "__VITE_ASSET__BAKDwHtc__"